import React, { useState, useEffect } from "react";
import Button from "../../../components/ui/Button";
import axios from "axios";
import API_BASE_URL from "../../../services/api";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../utils/axiosInstance";

const LatestPrescriptions = () => {
  const [prescriptions, setPrescriptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const fetchPrescriptions = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`${API_BASE_URL}/api/prescription`, {
        params: { page: 1, limit: 5 },
      });

      if (response.data.success) {
        setPrescriptions(response.data.data.slice(0, 5));
      }
    } catch (error) {
      console.error("Error fetching prescriptions:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPrescriptions();
  }, []);

  const getStatusColor = (status) => {
    switch (status) {
      case "APPROVED":
        return "text-green-600";
      case "PENDING_REVIEW":
        return "text-yellow-600";
      case "REJECTED":
        return "text-red-600";
      default:
        return "text-gray-500";
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    });
  };

  const truncateText = (text, maxLength = 15) => {
    if (!text) return "-";
    return text.length > maxLength 
      ? `${text.substring(0, maxLength)}...`
      : text;
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
      {/* Header */}
      <div className="border-b border-gray-200 px-4 py-3">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-sm font-semibold text-gray-900">
              Recent Prescriptions
            </h2>
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={() => navigate("/prescriptions")}
            className="text-xs py-1 px-3"
          >
            View All
          </Button>
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="w-full text-xs">
          <thead className="bg-gray-50">
            <tr>
              <th className="text-left py-2 px-4 font-medium text-gray-600 uppercase tracking-wider">
                Patient
              </th>
              <th className="text-left py-2 px-4 font-medium text-gray-600 uppercase tracking-wider">
                Contact
              </th>
              <th className="text-left py-2 px-4 font-medium text-gray-600 uppercase tracking-wider">
                File Type
              </th>
              <th className="text-left py-2 px-4 font-medium text-gray-600 uppercase tracking-wider">
                Status
              </th>
              <th className="text-left py-2 px-4 font-medium text-gray-600 uppercase tracking-wider">
                Upload Date
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {loading ? (
              <tr>
                <td colSpan="5" className="py-4 text-center">
                  <p className="text-xs text-gray-500">Loading...</p>
                </td>
              </tr>
            ) : prescriptions.length === 0 ? (
              <tr>
                <td colSpan="5" className="py-4 text-center">
                  <p className="text-xs text-gray-500">No prescriptions found</p>
                </td>
              </tr>
            ) : (
              prescriptions.map((prescription) => (
                <tr 
                  key={prescription.id} 
                  className="hover:bg-gray-50 transition-colors cursor-pointer"
                  onClick={() => window.open(prescription.fileUrl, "_blank")}
                >
                  {/* Patient */}
                  <td className="py-2 px-4">
                    <div className="font-medium text-gray-900">
                      {truncateText(prescription.patient?.fullName, 20) || "-"}
                    </div>
                  </td>
                  
                  {/* Contact */}
                  <td className="py-2 px-4">
                    <div className="text-gray-700">
                      {prescription.patient?.contactNo || "-"}
                    </div>
                  </td>
                  
                  {/* File Type */}
                  <td className="py-2 px-4">
                    <div className="text-gray-700 font-medium">
                      {prescription.fileType || "-"}
                    </div>
                  </td>
                  
                  {/* Status */}
                  <td className="py-2 px-4">
                    <div className={`font-medium ${getStatusColor(prescription.status)}`}>
                      {prescription.status?.replace("_", " ") || "-"}
                    </div>
                  </td>
                  
                  {/* Upload Date */}
                  <td className="py-2 px-4">
                    <div className="text-gray-700">
                      {formatDate(prescription.uploadedAt)}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LatestPrescriptions;